import { Box, Typography } from "@mui/material";

const Status = ({ cleared, light }) => (
  <Box
    component="span"
    sx={{
      mt: 1.5,
      px: 2,
      py: 0.45,
      border: `1px solid ${light ? "#8b0000" : "#fff"}`,
      borderRadius: 99,
      color: light ? "#8b0000" : "#fff",
      fontFamily: '"Noto Serif JP", serif',
      fontSize: 10,
      whiteSpace: "nowrap",
      boxShadow: cleared ? `0 0 8px ${light ? "#8b0000" : "#ff383c"}` : "none",
    }}
  >
    {cleared ? "クリア" : "未クリア"}
  </Box>
);

export default function OmagunQuestCard({ quest, variant = "quest", index = 0 }) {
  const light = variant === "mission";
  const trial = variant === "trial";

  if (trial) {
    return (
      <Box sx={{ width: "100%", textAlign: "center", mb: 3.5 }}>
        <Typography
          sx={{
            mb: 2,
            fontFamily: '"TamanegiKaishoGeki", serif',
            fontSize: 22,
            letterSpacing: ".08em",
          }}
        >
          試練 その{["一", "二", "三", "四"][index] || index + 1}
        </Typography>
        <Box
          component="img"
          src={quest.eye_catch_url}
          alt=""
          sx={{
            display: "block",
            width: "86%",
            aspectRatio: "16 / 9",
            mx: "auto",
            objectFit: "cover",
            filter: quest.is_cleared ? "none" : "grayscale(.55)",
          }}
        />
        <Typography
          sx={{
            mt: 1.2,
            fontFamily: '"TamanegiKaishoGeki", serif',
            fontSize: 18,
            color: quest.is_cleared ? "#fff" : "#c8c8c8",
            textShadow: quest.is_cleared ? "0 0 7px #ff383c" : "none",
          }}
        >
          {quest.name} {quest.is_cleared ? "通過!" : "未通過"}
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: 132,
        display: "grid",
        gridTemplateColumns: "50% 50%",
        overflow: "hidden",
        border: `1px solid ${light ? "#a00000" : "#6c2025"}`,
        backgroundColor: light ? "rgba(248,248,244,.72)" : "rgba(0,0,0,.72)",
        boxShadow: light ? "none" : "0 0 8px rgba(195,33,32,.5)",
      }}
    >
      <Box
        component="img"
        src={quest.eye_catch_url}
        alt=""
        sx={{ width: "100%", height: "100%", minHeight: 132, objectFit: "cover" }}
      />
      <Box sx={{ px: 2, py: 1.5, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <Typography
          sx={{
            color: light ? "#890000" : "#fff",
            fontFamily: light ? '"TamanegiKaishoGeki", serif' : '"Noto Serif JP", serif',
            fontSize: light ? 18 : 20,
            textAlign: "center",
            lineHeight: 1.3,
          }}
        >
          {quest.name}
        </Typography>
        <Typography
          sx={{
            mt: 1,
            color: light ? "#181212" : "#fff",
            fontFamily: '"Noto Serif JP", serif',
            fontSize: 11,
            lineHeight: 1.75,
            textAlign: "center",
          }}
        >
          {quest.description}
        </Typography>
        <Status cleared={quest.is_cleared} light={light} />
      </Box>
    </Box>
  );
}
